import { Link, useRouterState } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import type { VersionTab } from "./case-workspace-header";

const TABS: Array<{ id: VersionTab; label: string }> = [
  { id: "meta", label: "元信息" },
  { id: "pipeline", label: "流水线" },
  { id: "preview", label: "预览" },
  { id: "publish", label: "发布" },
  { id: "agent", label: "Agent" },
  { id: "assets", label: "素材" },
];

export function VersionLevelTabs({
  caseId,
  versionId,
}: {
  caseId: string;
  versionId: string;
}) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <nav className="-mb-px flex flex-wrap gap-0.5 border-b border-border">
      {TABS.map((tab) => {
        const isActive = pathname.endsWith(`/${tab.id}`);
        return (
          <Link
            key={tab.id}
            to={`/cases/$caseId/versions/$versionId/${tab.id}`}
            params={{ caseId, versionId }}
            className={cn(
              "relative inline-flex h-8 items-center px-2.5 text-sm font-medium text-foreground/55 transition-colors hover:text-foreground",
              isActive &&
                "text-foreground after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-foreground",
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
